@if ((scientificRigourPlayers$ | async); as scientificRigourPlayers) {
  <app-player-list name="Scientific Rigour" [columns]="scientificRigourColumns" [data]="scientificRigourPlayers"
    [totalPlayers]="scientificRigourPlayers.length" [showDownloadButton]="true"
    [worksheetColumns]="scientificRigourWorksheetColumns">
  </app-player-list>
}
